module.exports = __webpack_public_path__ + "img/card-banner.0cb2a7b3.png";